/* app/ui/map/map.interactive */

import $ from 'jquery';

var MapInteractive = {

};

export { MapInteractive }